module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "login"
    }
  }, [_c('header', {
    staticClass: "text-l"
  }), _vm._v(" "), _c('div', {
    staticClass: "logo"
  }), _vm._v(" "), _c('form', [_c('div', {
    staticClass: "flex vux-1px-b"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.phone),
      expression: "phone"
    }],
    staticClass: "flex-1",
    attrs: {
      "type": "tel",
      "name": "phone",
      "placeholder": "请输入手机号码",
      "maxlength": "11"
    },
    domProps: {
      "value": (_vm.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.phone = $event.target.value
      }
    }
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.phone.length > 0),
      expression: "phone.length>0"
    }],
    staticClass: "iconfont icon-cuowu",
    on: {
      "click": function($event) {
        _vm.phone = ''
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "iconfont icon-my"
  })]), _vm._v(" "), _c('div', {
    staticClass: "flex vux-1px-b"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pwd),
      expression: "pwd"
    }],
    ref: "pswd",
    staticClass: "flex-1",
    attrs: {
      "type": "password",
      "name": "pwd",
      "placeholder": "请输入密码"
    },
    domProps: {
      "value": (_vm.pwd)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.pwd = $event.target.value
      }
    }
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.pwd.length > 0),
      expression: "pwd.length>0"
    }],
    staticClass: "iconfont icon-cuowu",
    on: {
      "click": function($event) {
        _vm.pwd = ''
      }
    }
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.look),
      expression: "!look"
    }],
    staticClass: "iconfont icon-yincang",
    on: {
      "click": function($event) {
        _vm.look = true
      }
    }
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.look),
      expression: "look"
    }],
    staticClass: "iconfont icon-chakan",
    on: {
      "click": function($event) {
        _vm.look = false
      }
    }
  })])]), _vm._v(" "), _c('button', {
    staticClass: "login-btn",
    on: {
      "click": function($event) {
        _vm.loginBtn(_vm.phone, _vm.pwd)
      }
    }
  }, [_vm._v("登录")]), _vm._v(" "), _c('div', {
    staticClass: "btm-text"
  }, [_vm._v("\n        登录即表示同意"), _c('router-link', {
    staticClass: "public-red",
    attrs: {
      "to": "",
      "tag": "span"
    }
  }, [_vm._v("《生活道商城用户协议》")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5f3e0596"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Login/Login.vue
// module id = 579
// module chunks = 0